import codes from 'currency-codes';

const Currencies = codes.data.map((code) => ({
  id: code.code,
  name: code.currency,
}));

export default Currencies;
